import { InjectionToken } from '@angular/core';
import { StorageService } from '../services/configurators-2d/applications/storage.service';

export const ST_SERVICE = new InjectionToken(typeof StorageService);

export const storagesProviders = [
  {
    provide: ST_SERVICE,
    useClass: StorageService,
  },
];
